export const MAIN_LANGUAGE = 'de';

const urlify = str => str.replace(/[ ]/g, '-').replace(/['.:!?()]/g, '').toLowerCase();
const normalizeString = str => (str ? urlify(str.toLowerCase()) : null);
export const normalizeAttributes = (post) => {
  const {
    language, section, slug, date, ...rest
  } = post.attributes;
  return {
    language: normalizeString(language),
    section: normalizeString(section),
    slug: normalizeString(slug),
    date: (date && new Date(date)) || null,
    ...rest,
  };
};

const isValidDate = date => date && date.getDate() && !Number.isNaN(date.getDate());
const getDatePath = date => `/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;

export const getRouteFromPost = (post) => {
  const {
    language, section, slug, date, title,
  } = normalizeAttributes(post);
  let route = '';

  route += language && language !== MAIN_LANGUAGE ? `/${language}` : '';
  route += section ? `/${section}` : '';

  if (slug) {
    return `${route}/${slug}`;
  }

  route += isValidDate(date) ? getDatePath(date) : '';
  route += `/${normalizeString(title) || normalizeString(post.name.replace(/.md$/i, ''))}`;
  return route;
};
